import _ from 'lodash'
import {
  PROPOSAL_PHASE_TYPE,
  PROPOSAL_REVIEW_STATUS_MAP,
  PROPOSAL_EXECUTE_STATUS,
  PROPOSAL_EXECUTE_STATUS_MAP,
  PROPOSAL_DECLINE_REASON
} from '@vzmi/shp_shared_compo/constants/proposal'
import { INFO } from '../../../../../../constants/globalTypes'
import { HyperLink } from '../../../../../Common/Form'
import { ConnectedListingLink } from '../../../../../Common/ListingLink/ListingLink'
import PrefixBlock from '../../../PrefixBlock'

const getBadword = (declineDetail) => {
  if (!declineDetail) {
    return ''
  }
  return declineDetail.replace('內容含有不合法文字: ', '')
}

const StatusSuccessPrefixBlock = props => {
  const {
    proposalType,
    listing: {
      id: listingId
    } = {},
    successProposal: {
      id: proposalId,
      reviewStatus,
      executeStatus,
      declineReason = [],
      declineDetail = null
    } = {},
    isOverviewPage
  } = props

  const url = `/proposal/${proposalType}/${PROPOSAL_PHASE_TYPE.OVERVIEW}`
  const isBadWord = PROPOSAL_DECLINE_REASON.BADWORD in _.keyBy(declineReason)
  const badWord = getBadword(declineDetail)

  return (
    <PrefixBlock
      type={INFO}
      className='success'
    >
      <>
        提案編號：
        <HyperLink
          key='proposalId'
          target='_blank'
          href={`${url}?id=${proposalId}`}
        >
          {proposalId}
        </HyperLink>
        {(isOverviewPage && reviewStatus) && (
          <span key='reviewStatus'>
            {' | 提案單狀態：'}
            {isBadWord
              ? (
                <>
                  審核不通過，內容含有不合法文字：
                  <HyperLink
                    target='_blank'
                    href={`/keyword/query?displayName=${encodeURIComponent(badWord)}`}
                  >
                    {badWord}
                  </HyperLink>
                </>
              )
              : (
                PROPOSAL_REVIEW_STATUS_MAP[reviewStatus]
              )}
          </span>
        )}
        {(isOverviewPage && executeStatus) && (
          <span key='executeStatus'>
            {' | 賣場執行狀態：'}
            {PROPOSAL_EXECUTE_STATUS_MAP[executeStatus]}
            {
              executeStatus === PROPOSAL_EXECUTE_STATUS.FINISHED && (
                <>
                  ，賣場編號-
                  <ConnectedListingLink targetListingId={listingId}>
                    {listingId}
                  </ConnectedListingLink>
                </>
              )
            }
          </span>
        )}
      </>
    </PrefixBlock>
  )
}

export default StatusSuccessPrefixBlock
